// routes
import { PATH_SETTINGS } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/commonComponents/SvgIconStyle';
// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = { 
  activities: getIcon('activities'),
  idm: getIcon('id_card'),
};

const sidebarConfig = [
  {
    subheader: 'Company',
    items: [
      {
        title: 'Activity notification',
        path: PATH_SETTINGS.Notification,
        icon: ICONS.activities
      },
      {
        title: 'IDM Email Templates',
        path: PATH_SETTINGS.IdmEmailTemplate,
        icon: ICONS.idm
      }
    ]
  }
];

export default sidebarConfig;